let id_seq = 0;
const next = () => ++id_seq;

class LockClient {

    updateRecordOnServer(table, id, username) {
        this._addViolator(table, id, "optimistic", username, true);
    }

    openRecordInNewClient(table, id, username) {
        this._addViolator(table, id, "pessimistic", {
            id: next(),
            username
        });
    }

    _addViolator(table, id, type, violator) {
        const munge = obj => {
            const key = type + "Violators";
            if (!obj[key]) {
                obj[key] = [];
            }
            if (obj[key].indexOf(violator) < 0) {
                obj[key].push(violator);
            }
        };

        this._workOnLock(table, id, (ls, l) => {
            munge(l);
            munge(ls);
        });
    }

    _workOnLock(table, id, work) {
        if (!this.locksets) return;
        Object.values(this.locksets).forEach(ls => {
            if (!ls.locks.hasOwnProperty(table)) return;
            // noinspection EqualityComparisonWithCoercionJS
            ls.locks[table]
                .filter(l => l.id == id)
                .forEach(l => work(ls, l));
        });
    }

    closeRecordInOtherClient(table, id, username) {
        const gonk = () => {
            throw new Error(`${username} does not have ${table}#${id} open`);
        };

        const munge = obj => {
            if (!obj.pessimisticViolators) gonk();
            const idx = obj.pessimisticViolators.findIndex(v => v.username === username);
            if (idx < 0) gonk();
            if (obj.pessimisticViolators.length === 1) {
                obj.pessimisticViolators = null;
            } else {
                obj.pessimisticViolators.splice(idx, 1);
            }
        };

        this._workOnLock(table, id, (ls, l) => {
            munge(l);
            munge(ls);
        });
    }

    createClient() {
        this.id = next();
        this.locksets = {};
        return {
            id: this.id,
            username: "alice",
        };
    }

    createLockSet(data) {
        const id = next();
        this.locksets[id] = {
            id,
            acquiredAt: Date.now(),
            confirmedAt: Date.now(),
            locks: data.locks,
        };
        return this.locksets[id];
    }

    confirmLockSet(id) {
        this.locksets[id].confirmedAt = Date.now();
        return this.locksets[id];
    }

    releaseLockSet(id) {
        delete this.locksets[id];
        return {id: parseInt(id, 10)};
    }

    releaseClient(id) {
        delete this.id;
        delete this.locksets;
        return {id: parseInt(id, 10)};
    }

}

export default new LockClient();



// WEBPACK FOOTER //
// ./test/mock/lib/lockClient.js